class DrawerCartNote extends HTMLElement {
  constructor() {
    super();

    this.textarea = this.querySelector("#CartDrawer-note");
    this.status = this.querySelector("[data-cart-note-status]");
    this.counter = this.querySelector("[data-cart-note-count]");
    this.maxLength = parseInt(this.textarea.getAttribute("maxlength"), 10) || 50;

    this.save = debounce(() => {
      const body = JSON.stringify({ note: this.textarea.value });
      this.setStatus("Saving…");
      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
        .then(() => this.setStatus("Saved", true))
        .catch(() => this.setStatus(""));
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.textarea.addEventListener("input", () => {
      this.updateCounter();
      this.save();
    });

    this.updateCounter();
  }

  updateCounter() {
    if (!this.counter) return;
    const length = this.textarea.value.length;
    this.counter.textContent = `${length} / ${this.maxLength}`;
    this.counter.classList.toggle(
      "is-near-limit",
      length >= this.maxLength * 0.9,
    );
  }

  setStatus(text, autoClear = false) {
    if (!this.status) return;
    this.status.textContent = text;
    if (autoClear) {
      clearTimeout(this._clear);
      this._clear = setTimeout(() => {
        this.status.textContent = "";
      }, 2000);
    }
  }
}

customElements.define("drawer-cart-note", DrawerCartNote);
